/**
 * Considering that the subscription and the temp server event are triggered before the login event,
 * and adding a delay of 1 second to ensure that
 * we can assume that when the login happens, we already have the data from the subscription and temp server events.
 *
 * When in a temp server, according to the game the subscription event will either not be triggered (empire) or will be triggered with a false value (bigfarm).
 * P.S. The temp server event happens after the subscription event when in bigfarm
 * When an unexpected error happens, we cannot do much, that's why we are initializing the subscription flag as true.
 */

import { ILoginData } from '@goodgamestudios/cxf-events'
import { CXF } from '@goodgamestudios/cxf-runtime'
import { CxfEvents } from '../constants'
import { delay } from '../utils/utils'
import log from '../utils/logger'

// Initializing as false because the first login should never be a temp server login
let tempServerFlag = false
// Initializing as true because it's better to assume the player has a subscription and hide the banners than the opposite
let hasSubscriptionFlag = true

const subscribeJoinTempServer = (cxf: CXF) => {
  log(`Waiting for ${CxfEvents.JoinTempServer} event`)
  cxf.on(CxfEvents.JoinTempServer, (isTempServer: boolean) => {
    log(`${CxfEvents.JoinTempServer} received`, { isTempServer })
    tempServerFlag = isTempServer
  })
}

const subscribeSubscriptionEvent = (cxf: CXF) => {
  log(`Waiting for ${CxfEvents.Subscription} event`)
  cxf.on(CxfEvents.Subscription, (hasSubscription: boolean) => {
    log(`${CxfEvents.Subscription} received`)
    hasSubscriptionFlag = hasSubscription
  })
}

// Todo: remove this type when cxf-events will be updated
export type AdBannersLoginData = Omit<ILoginData, 'hasSubscription'> & {
  isTempServer: boolean
  hasSubscription: boolean
}

export const aggregateLoginData = (cxf: CXF, callback: (allLoginData: AdBannersLoginData) => void) => {
  try {
    subscribeJoinTempServer(cxf)
    subscribeSubscriptionEvent(cxf)

    cxf.on(CxfEvents.Login, async (loginData: ILoginData) => {
      // just to make sure that the subscription and temp server events will be triggered before the login logic
      await delay(3000)

      const adBannersLoginData: AdBannersLoginData = {
        ...loginData,
        hasSubscription: hasSubscriptionFlag,
        isTempServer: tempServerFlag,
      }

      log('Ad banners login data', adBannersLoginData)

      callback(adBannersLoginData)
    })
  } catch (error) {
    log('Error while waiting for login data: %O', error)
    throw new Error('Error while waiting for login data')
  }
}
